import { createAsyncThunk } from '@reduxjs/toolkit'
import { webNotificationManagementAPI } from '@services/api/webNotificationManagementAPI'

export const fetchWebNotificationList = createAsyncThunk(
  'webNotificationManagement/fetchWebNotificationList',
  async (params: TNotificationManagementAPI.Params.FetchList, { rejectWithValue }) => {
    try {
      const response = await webNotificationManagementAPI.fetchList(params)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const publishWebNotification = createAsyncThunk(
  'webNotificationManagement/publishWebNotification',
  async (data: TWebNotificationManagement.TState['notificationDetail']['data'], { rejectWithValue }) => {
    try {
      const response = await webNotificationManagementAPI.publishNotification(data)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const updateWebNotification = createAsyncThunk(
  'webNotificationManagement/updateWebNotification',
  async (data: TWebNotificationManagement.TState['notificationDetail']['data'], { rejectWithValue }) => {
    try {
      const response = await webNotificationManagementAPI.updateNotification(data)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const fetchSingle = createAsyncThunk(
  'webNotificationManagement/fetchSingle',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await webNotificationManagementAPI.fetchSingle(id)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)
